module.exports = __webpack_public_path__ + "static/img/pdf.89a27392.png";